import { z } from 'zod';
// --- Changelog entry type ---
export const CHANGELOG_ACTIONS = ['create', 'update', 'delete', 'status_change'];
export const CHANGELOG_RESOURCE_TYPES = [
    'project',
    'experiment',
    'flag',
    'exclusion_group',
    'api_key',
];
export const changelogEntrySchema = z
    .object({
    id: z.string(),
    action: z.enum(CHANGELOG_ACTIONS),
    resource_type: z.enum(CHANGELOG_RESOURCE_TYPES),
    resource_id: z.string(),
    previous_state: z.unknown().nullable(),
    new_state: z.unknown().nullable(),
    user_email: z.string(),
    timestamp: z.string(),
    summary: z.string(),
})
    .meta({ id: 'ChangelogEntry', description: 'Audit log entry for admin mutations' });
//# sourceMappingURL=changelog.js.map